// extracted by mini-css-extract-plugin
export default {"icon":"UeIcon_icon_GgekW"};